import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import { Button, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { INPUTS_PROPS } from "../../../../enums/Enums";
import Strings from "../../../../resources/Strings";
import * as actionsService from "../../../../services/ActionsService/ActionsService";
import { getErrorMessage, isRequired, isValidPassword } from "../../../../utils/FormUtils";
import classes from "../CustomInputs.module.css";
import PasswordInput from "./PasswordInput";
import TextInput from "./TextInput";
import CustomTooltip  from "../../Tooltip/CustomTooltip/CustomTooltip";

const VerificationPasswordInput = (props) => {
  const [showVerificationMessage, setShowVerificationMessage] = useState(false);
  const [isVerifiy, setIsVerifiy] = useState(true);
  const [isVerificationClicked, setIsVerificationClicked] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [verifiyErrorMessage, setVerifiyErrorMessage] = useState("");
  const [showTooltip, setShowTooltip] = useState(true);

  const [formData, setFormData] = useState({
    currentPassword:"",
    newPassword: "",
    repeatPassword: "",
    isCurrentStepValid: false,
    isStepSubmitted: false,
  });

  useEffect(() => {
    const hasError = Object.values(errors).some((hasError) => hasError);
    handleCurrentStepValidity(hasError);
  }, [errors]);

  const handleCurrentStepValidity = (hasError) => {
    setFormData({ ...formData, isCurrentStepValid: !hasError });
  };

  const handleClose = () => {
    setIsVerifiy(true);
    setShowVerificationMessage(false);
    setShowTooltip(true);
    setSuccessMessage("") 
  };

  const handleOpen = () => {
    setShowVerificationMessage(true);
    setShowTooltip(false);
    setSuccessMessage("")
  };

  useEffect(() => {
    if (props.handleError) {
      setIsVerificationClicked(false);
    }
  }, [props.value, isVerifiy]);

  const validateForm = () => {
    const passwordValidation = isValidPassword(
      formData.newPassword,
      formData.repeatPassword
    );
    if (!passwordValidation.isValid) {
        setVerifiyErrorMessage(passwordValidation.errorMessage);
    }
    
    return passwordValidation.isValid;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setFormData({ ...formData, ["isStepSubmitted"]: true });
    const isValidForm = validateForm();
    if (isValidForm && formData.isCurrentStepValid) {
      actionsService
        .updatePassword(props.userId, formData.newPassword, formData.currentPassword)
        .then((response) => {
          if (response.data.isSuccess) {
            setShowVerificationMessage(false);
            setSuccessMessage(Strings.CHANGED_SUCCESSFULY);
          } else {
            setVerifiyErrorMessage(response?.data?.error?.errorTitle);
          }
        })
        .catch((error) => {});
    }
  };

  const handleChange = (event) => {
    setVerifiyErrorMessage("");
    setFormData({ ...formData, ...event });
    setIsVerifiy(false);
  };

  return (
    <div className={showTooltip ? [classes.customTextField, classes.passwordInput].join(' ') : classes.customTextField}>
      <TextField
        fullWidth
        label={props.label}
        id={props.id}
        name={props.id}
        type={"password"}
        className={classes.textField}
        defaultValue={props.value}
        disabled={true}
        onChange={handleChange}
        InputLabelProps={{ shrink: true }}
        InputProps={{
          classes: {
            notchedOutline: classes.filed,
          },
          endAdornment: (
            <span className={classes.endAdornment}>
              {!showVerificationMessage && (
                <Button className={classes.inputButton} onClick={handleOpen}>
                  {props.isEditMode ? Strings.CHANGE : ""}
                </Button>
              )}
              {isVerifiy && (props.isStepSubmitted || isVerificationClicked) && (
                <Button className={classes.inputButton}>
                  <CheckCircleOutlineOutlinedIcon color="success" />
                </Button>
              )}
            </span>
          ),
        }}
        FormHelperTextProps={{
          classes: {
            error: classes.error,
          },
        }}
      />
      {showTooltip && (
        <CustomTooltip {...props} isOutOfField={true}></CustomTooltip>
      )}
      {showVerificationMessage && (
        <div className={classes.codeVerification}>
          <span className={classes.verificationMessage}>
            {Strings.CHANGE_PASSWORD_MESSAGE}
          </span>
          <div className={classes.action}>
            <TextInput
              label={Strings.INPUT_LABELS.CURRENT_PASSWORD}
              id={INPUTS_PROPS.CURRENT_PASSWORD}
              type={"password"}
              value={formData.currentPassword}
              onChange={handleChange}
              isStepSubmitted={formData.isStepSubmitted}
              handleError={props.handleError}
              hasError={!isRequired(formData.currentPassword).isValid}
              errorMessage={getErrorMessage(
                isRequired(formData.currentPassword)
              )}
              showTooltip={false}
            />
            <PasswordInput
              label={Strings.INPUT_LABELS.NEW_PASSWORD}
              id={INPUTS_PROPS.NEW_PASSWORD}
              value={formData.newPassword}
              onChange={handleChange}
              isStepSubmitted={formData.isStepSubmitted}
              handleError={props.handleError}
              hasError={!isRequired(formData.newPassword).isValid}
              errorMessage={getErrorMessage(
                isRequired(formData.newPassword)
              )}
              showTooltip={showTooltip}
              {...props}
            />
            <PasswordInput
              label={Strings.INPUT_LABELS.REPEAT_PASSWORD}
              id={INPUTS_PROPS.REPEAT_PASSWORD}
              value={formData.repeatPassword}
              onChange={handleChange}
              isStepSubmitted={formData.isStepSubmitted}
              handleError={props.handleError}
              hasError={!isRequired(formData.repeatPassword).isValid}
              errorMessage={getErrorMessage(
                isRequired(formData.repeatPassword)
              )}
              showTooltip={false}
            />
            <Button className={classes.formButton} onClick={handleSubmit}>
              {Strings.CONFIRM}
            </Button>
            <Button className={classes.cancelButton} onClick={handleClose}>
              {Strings.CANCEL}
            </Button>
          </div>
          {!isVerifiy && formData.isStepSubmitted && (
            <div className={classes.error}>{verifiyErrorMessage}</div>
          )}
        </div>
      )}
      {formData.isStepSubmitted && successMessage && (
        <div className={classes.successMessage}>
          <span>{successMessage}</span>
        </div>
      )}
    </div>
  );
};

export default VerificationPasswordInput;
